import React from "react";
import { Form } from "semantic-ui-react";
import { useExtLabels } from '../common/extLabels'

const Agreements = ({ model, errors = {}, onChange, disabled, termsAndConditions }) => {
    const l = useExtLabels()

    const handleChange = (name, value) => onChange({ ...model, [name]: value });

    return (
        <React.Fragment>
            <Form.Checkbox
                disabled={disabled}
                label={l("zgoda na przesyłanie informacji o konkursie i gali e-Commerce Polska Awards")}
                error={!!errors.notifyAboutCompetition}
                name="notifyAboutCompetition"
                checked={model.notifyAboutCompetition}
                onChange={(target, { name, checked } ) => handleChange(name, checked)}
                required
            />
            <Form.Checkbox
                disabled={disabled}
                label={l("zgoda na informacje o innych aktywnościach Izby Gospodarki Elektronicznej")}
                error={!!errors.notifyAboutOtherActivities}
                name="notifyAboutOtherActivities"
                checked={model.notifyAboutOtherActivities}
                onChange={(target, { name, checked } ) => handleChange(name, checked)}
            />
            <Form.Checkbox
                label={<label>{l("akceptuję")} <a href={termsAndConditions} target="_blank">{l("regulamin")}</a></label>}
                disabled={disabled}
                error={!!errors.termsAndConditions}
                name="termsAndConditions"
                checked={model.termsAndConditions}
                onChange={(target, { name, checked } ) => handleChange(name, checked)}
                required
            />
        </React.Fragment>
    );
};

export default Agreements;